"use client";
import { Link as MuiLink } from "@mui/material";
import { type IconProps } from "@phosphor-icons/react";
import {
  createLink,
  type NavigateOptions,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";
import { type ReactElement } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { WHATSAPP_URL } from "@/utils/constants";

const CustomLink = createLink(MuiLink);

export interface PageErrorProps {
  title?: string;
  subtitles: string[];
  link?: {
    text: string;
    options: NavigateOptions;
  };
  icon?: ReactElement<IconProps>;
  back: {
    text: string;
    options?: NavigateOptions;
  };
  hideWhatsAppButton?: boolean;
}

function PageError({
  back,
  icon,
  title,
  subtitles,
  link,
  hideWhatsAppButton,
}: PageErrorProps) {
  const intl = useIntl();
  const navigate = useNavigate();
  const { history } = useRouter();

  const handleBackButtonClick: React.MouseEventHandler<
    HTMLButtonElement
  > = () => {
    if (back.options) {
      navigate(back.options);
    } else {
      history.back();
    }
  };

  return (
    <div className="flex h-screen w-full flex-col items-center p-10">
      <div className="mt-[30%] flex flex-col items-center gap-4">
        {icon ? icon : null}
        {title ? (
          <span className="text-center text-xl font-bold text-text-primary">
            {title}
          </span>
        ) : null}
        {subtitles.map((subtitle, idx) => (
          <span key={idx} className="text-center text-sm text-text-primary">
            {subtitle}
          </span>
        ))}
        {link ? (
          <CustomLink className="mb-4" {...link.options}>
            {link.text}
          </CustomLink>
        ) : null}
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={handleBackButtonClick}
        >
          {back.text}
        </Button>
      </div>
      {hideWhatsAppButton ? null : (
        <div style={{ marginTop: "auto" }}>
          <Button
            onClick={() => {
              window.open(WHATSAPP_URL, "_blank");
            }}
            color="primary"
            variant="text"
          >
            {intl.formatMessage({ id: "contactWhatsAppSupport" })}
          </Button>
        </div>
      )}
    </div>
  );
}

export default PageError;
